<p-dialog
  [(visible)]="importErrorDialogVisible"
  [modal]="true"
  [style]="{ width: '42rem', maxWidth: '95vw' }"
  [draggable]="false"
  [resizable]="false"
  >
  <ng-template #header>
    <div class="d-flex align-items-center gap-2">
      <i class="ri-error-warning-fill text-danger fs-4"></i>
      <span i18n="@@import-error-report-header">Import abgebrochen</span>
    </div>
  </ng-template>

  <p
    class="mb-3"
    i18n="@@import-error-report-message"
    >
    Der Import wurde vollständig zurückgedreht. Prüfe die Fehler und korrigiere die betroffenen Inhalte vor dem nächsten
    Versuch.
  </p>

  @if (importFailureMessage) {
    <div
      class="mb-3"
      >
      <strong i18n="@@import-error-summary-label">Zusammenfassung:</strong>
      <div>{{ importFailureMessage }}</div>
    </div>
  }

  @if (importFailureReport; as report) {
    @if (report.errors.length) {
      <div>
        <h6 i18n="@@import-error-report-errors">Fehler</h6>
        <ul class="mb-3">
          @for (err of report.errors; track err) {
            <li>
              <span>{{ err.message }}</span>
              @if (err.itemName) {
                <span> ({{ err.itemName }})</span>
              }
            </li>
          }
        </ul>
      </div>
    }
    @if (report.cleanupWarnings.length) {
      <div>
        <h6 i18n="@@import-error-report-cleanup">Hinweise zur Bereinigung</h6>
        <ul class="mb-0">
          @for (warning of report.cleanupWarnings; track warning) {
            <li>
              {{ warning.scope }}: {{ warning.message }}
            </li>
          }
        </ul>
      </div>
    }
  }

  <ng-template #footer>
    <p-button
      (click)="importErrorDialogVisible = false"
      i18n-label="@@understood"
      label="Verstanden"
      severity="secondary"
      />
  </ng-template>
</p-dialog>

@if (this.invalidToken) {
  <div
    class="d-flex align-items-center justify-content-center w-100 h-100"
    >
    <div class="w-50 text-center">
      <h2 i18n="@@bot-import">
      Bot Import
    </h2>
      <h5 i18n="@@bot-import-error">
      Dieser Import-Link ist ungültig.
    </h5>
      <h5 i18n="@@bot-import-error-contact">
      Wende dich an den Bot-Besitzer.
    </h5>
      <p class="card-text mx-3 text-center">
        <p-button
          label="Zurück zur Bot-Übersicht"
          i18n-label="@@btn-back-to-bots"
          [routerLink]="['/','bot-admin']"
          />
      </p>
    </div>
  </div>
}




@if (!this.invalidToken) {
  <div
    class="d-flex align-items-center justify-content-center w-100 h-100"
    >
    <div class="w-50">
      <h2
        class="card-title mx-3 text-center"
        i18n="@@bot-access"
      >Bot Freigabe</h2>
      <p
        class="card-text mx-3 text-center"
        i18n="@@bot-import-text"
        >Um den Bot in dein Konto zu übernehmen, klicke bitte auf <u
        (click)="this.importBot()"
        class="cursor-pointer"
      >Importieren</u>.
    </p>
    <div class="row mx-3 mt-5">
      <div class="col">
        <div
          class=" card p-2 text-center w-75 m-auto"
          [ngStyle]="{'background-color': this.botConfig?.color, 'color':getContrastColor(this.botConfig?.color ? this.botConfig!.color : '#000000')}"
          [ngStyle]="{'background-color': this.botConfig?.color, 'color': getContrastColor(this.botConfig?.color ? this.botConfig!.color : '#000000')}"
          >
          <i [class]="this.botConfig?.icon +' ri-2x'"></i>
          <span> {{ this.botConfig?.name }}</span>
          <app-bot-quickinfo
            [botConfig]="this.botConfig!"
            [showIcon]="false"
            [colorMode]="false"
            >
          </app-bot-quickinfo>
        </div>
      </div>
    </div>
    <div class="row m-4">
      <div class="col text-center">
        @if (this.importing) {
          <div
            class="spinner-border text-primary"
            role="status"
            >
            <span
              class="visually-hidden"
              i18n="@@loading"
            >Loading...</span>
          </div>
        }
      </div>
    </div>
    <div class="row m-3 ">
      <div class="col text-center">
        <p-button
          label="Diesen Bot Importieren"
          i18n-label="@@btn-import-bot"
          size="large"
          (click)="this.importBot()"
          [disabled]="importing"
          />
      </div>
    </div>
  </div>
</div>
}